import { createTheme } from '@mui/material/styles';

export const announcementsPageTheme = createTheme({
  palette: {
    primary: {
      main: '#1456E0',
    },
  },

  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Open Sans',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: `${theme.palette.primary.main} !important`,
        }),
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        title: {
          fontFamily: 'Red Hat Display',
          fontWeight: 700,
          paddingBottom: '20px',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          paddingTop: '6px !important',
          paddingRight: '16px !important',
          paddingLeft: '16px !important',
          paddingBottom: '6px !important',
          borderRadius: '0px !important',
          width: '100% !important',
          justifyContent: 'left !important',
          fontWeight: '400 !important',
          fontSize: '1rem !important',
          fontFamily: 'Open Sans !important',
        },
      },
    },
  },
});
